import { Button, Col, Descriptions, Divider, Form, Input, InputNumber, message, Row, Select, Table } from "antd";
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import { request } from "../../../../shared/src/apis";
import { BasicUserInfo } from '@operations/shared';
import { stepperMoving } from "../../stores/actions";
import { refundActiveRequestsAPI } from "../../utils/apisConsts";
import { errorMessage } from "../../utils/commonStringsConsts";
import { activeRequestsColumns } from "../../utils/tableColumns";
import moment from "moment";

interface Props {
    userInfo: any,
    requestDetails: any
}

export default function RefundActiveRequestForm({ userInfo, requestDetails }: Props) {
    const [sending, setSending] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { Option } = Select;
    const submitRefund = async (values: { refundedAmount: number, comment: string, paymentCycle: number }) => {
        try {
            setSending(true)
            const response: any = await dispatch(request({
                url: refundActiveRequestsAPI, method: "POST",
                data: {
                    phone: userInfo?.phone,
                    totalAmount: values?.refundedAmount,
                    comment: values?.comment,
                    advanceID: requestDetails?.advanceID,
                    refundCycle: values?.paymentCycle ?? requestDetails?.defaultSelection?.paymentCycle
                }
            }))

            if (response?.data?.status === 200) { //success
                message.success(response?.data?.message, 4)
                dispatch(stepperMoving(0))
            }
            else {
                message.error(`${response?.data?.message}, ${response?.data?.errorData ? "Reason: " + response?.data?.errorData : ""}`, 4)
            }
            setSending(false)
        }
        catch (error: any) {
            console.log("🚀 ~ file: refundInActiveRequestsForm.tsx:91 ~ submitRefund ~ error", error)
            message.error(errorMessage)
            setSending(false)
        }
    }
    useEffect(() => {
        form.setFieldsValue({ ubComingRevenue: requestDetails?.defaultSelection?.upcomingRevenue});
    }, [form, requestDetails])

    return (
        <div className="refundRequest">

            {requestDetails?.installments?.length ? <>
                <Divider orientation="left">Request #{requestDetails?.advanceID}</Divider>
                <Descriptions bordered>
                    <Descriptions.Item label="Requested Amount" span={1}>{requestDetails?.requestedAmount}</Descriptions.Item>
                    <Descriptions.Item label="Service" span={1}>{requestDetails?.serviceTypeName}</Descriptions.Item>
                    <Descriptions.Item label="Transaction Status" span={1}>{requestDetails?.transactionStatusName}</Descriptions.Item>
                </Descriptions>
                <Divider orientation="left">Request Installments</Divider>
                <Table
                    pagination={false}
                    onChange={() => { }}
                    columns={activeRequestsColumns}
                    dataSource={requestDetails?.installments?.sort((a: { instalmentOrder: number }, b: { instalmentOrder: number }) => a?.instalmentOrder - b?.instalmentOrder)}
                    scroll={{ x: 'max-content' }}
                />
                <Form form={form} name="nest-messages" onFinish={submitRefund} initialValues={{ ubComingRevenue: requestDetails?.requestOpendedPaymentCycle?.[0]?.upcomingRevenue }} >
                    <Row>

                        <Col span='8'>
                            <label>Refund Amount <span>*</span></label>

                            <Form.Item
                                name="refundedAmount"
                                rules={[{ required: true, message: 'Required' }, { type: "number", min: 10, message: "Refund amount can't be less than 10 EGP" }]}
                            >
                                <InputNumber placeholder="Enter refund amount" />
                            </Form.Item>
                        </Col>
                        <Col span='8'>
                            <label>Upcoming  Revenue </label>

                            <Form.Item
                                name="ubComingRevenue"
                                initialValue={requestDetails?.defaultSelection?.upcomingRevenue}
                            >
                                <InputNumber placeholder="Upcoming Revenue" readOnly
                                />
                            </Form.Item>
                        </Col>
                        <Col className='refundCycles' span='8'>
                            <label>Payment Cycle </label>

                            <Form.Item
                                name="paymentCycle"
                            >
                                <Select
                                    onChange={(value: number, option: any) => {
                                        form.setFieldsValue({ ubComingRevenue: option?.revenue });
                                    }}
                                    placeholder="Select payment cycle"
                                    defaultValue={requestDetails?.defaultSelection?.paymentCycle}>
                                    {requestDetails?.requestOpendedPaymentCycle?.map((paymentCycle: { id: number, paymentCycle: number, cutOffCycleDate: string, upcomingRevenue: number }) => {
                                        return <Option value={paymentCycle?.paymentCycle} revenue={paymentCycle?.upcomingRevenue} key={paymentCycle?.id}>{moment(paymentCycle?.cutOffCycleDate)?.format('MMMM YYYY')}</Option>
                                    })}
                                </Select>
                            </Form.Item>

                        </Col>
                        <Col span='24'>
                            <Form.Item
                                name="comment"
                                rules={[{ required: true, message: 'Required' }]}
                            >
                                <Input.TextArea placeholder="Enter a comment" />
                            </Form.Item>
                        </Col>
                        <Col span='24' className="btnCol">
                            <Button shape="round" type="primary" block htmlType="submit" loading={sending}>
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </> : ""
            }
            <Divider orientation="left">User Information</Divider>
            <BasicUserInfo info={userInfo} />
        </div>
    )
}